<template>
  <div class="OrderFormContainer">
    <transition name="slide-left" mode="out-in">
      <router-view ref="routerView" />
    </transition>
  </div>
</template>

<script>
export default {
  components: {},
  mounted () {},
  data () {
    return {};
  },
  methods: {
    onSetOrderForm () {
      if (this.$refs.routerView.onSetOrderForm) {
        this.$refs.routerView.onSetOrderForm();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
// .OrderFormContainer {
// }
</style>
